import './Design.scss';

import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { DesignContext, DesignProvider } from '@/v2/state/providers';
import { StateContext } from '@/v2/state/store';
import query from '@/v2/state/query';
import Scenes from './__scenes__';
import ScenesHandler from '../../../components/application/ScenesHandler';

const onReady = () => {};

const DesignComponent = ({ scenes }) => {
    const store = useContext(StateContext);
    const history = useHistory();

    useEffect(() => {
        const { dispatch } = store;
        dispatch({ type: 'ROUTE_LOAD' });
    }, []);

    const onFinished = () => {
        history.push('scenes.html#design');
    };

    return (
        <div className="Design">
            {scenes && (
                <ScenesHandler onReady={onReady} onFinished={onFinished} momentName="serenely">
                    <Scenes.Awaken data={scenes[0]} path="awaken" />
                    <Scenes.LookAround data={scenes[1]} path="lookaround" />
                    <Scenes.Hotspots data={scenes[2]} path="hotspots" />
                    <Scenes.Exterior data={scenes[3]} path="exterior" />
                </ScenesHandler>
            )}
        </div>
    );
};

const DesignRenderer = () => {
    const [data, setter] = useContext(DesignContext);
    query(window.HELIOS.selectors.serenely, setter); // TODO: update key once corresponding AEM rename is done

    return <DesignComponent scenes={data.scenes} />;
};

const Design = () => (
    <DesignProvider>
        <DesignRenderer />
    </DesignProvider>
);

export default Design;
